import { useEffect, useState } from "react";
import { api } from "../../lib/api";

// VAGUE 46 — progression formation par télépro.
export default function AdminTrainingPanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/telepro/training-progress").then((r) => setData(r.data)).catch(() => setData({ error: true })); }, []);

  if (!data) return <div className="text-sm text-muted-foreground">Chargement…</div>;
  if (data.error) return <div className="text-sm text-secondary">Progression indisponible.</div>;
  return (
    <div className="bg-card border border-border rounded-sm p-4 overflow-x-auto" data-testid="admin-training-panel">
      <p className="text-xs text-muted-foreground mb-3">Meilleure note par module (validé à partir de {data.pass_score}/10).</p>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-wider text-muted-foreground border-b border-border">
            <th className="py-2 pr-3">Télépro</th>
            {data.modules.map((m) => <th key={m.id} className="py-2 px-2 whitespace-nowrap">{m.title}</th>)}
            <th className="py-2 pl-2">Validés</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((t) => (
            <tr key={t.id} className="border-b border-border/60" data-testid={`admin-training-row-${t.code}`}>
              <td className="py-2 pr-3 whitespace-nowrap font-medium">{t.first_name} {t.last_name} <span className="text-xs text-muted-foreground">{t.code}</span></td>
              {data.modules.map((m) => {
                const s = t.modules[m.id];
                return (
                  <td key={m.id} className={`py-2 px-2 text-center ${s ? (s.best_score >= data.pass_score ? "text-emerald-700 font-semibold" : "text-amber-700") : "text-muted-foreground"}`}>
                    {s ? `${s.best_score}/10` : "—"}
                  </td>
                );
              })}
              <td className="py-2 pl-2 font-semibold">{t.completed}/{data.modules.length}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
